import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { accessToken, clearAccess, playbookRequest } from '../../lib/playbooks'

export function RememberedReader({ playbookId, next, onReset }: { playbookId: string; next: string; onReset: () => void }) {
  const navigate = useNavigate()
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  async function unlock() {
    setBusy(true); setError('')
    try { await playbookRequest('unlock', { playbookId }); navigate(next) }
    catch (err) { if (!accessToken()) onReset(); else setError(err instanceof Error ? err.message : 'Please try again.') }
    finally { setBusy(false) }
  }
  return <div className="resource-returning"><p>Your reader access is saved on this browser. Keep going without entering your email again.</p><button className="resource-button" type="button" disabled={busy} onClick={unlock}>{busy ? 'Opening your playbook…' : 'Unlock this playbook'}</button>{error && <p role="alert">{error}</p>}<button className="resource-switch-reader" type="button" onClick={() => { clearAccess(); onReset() }}>Use a different email</button></div>
}
